import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import axios from "axios";

import TicketForm from "../../components/Admin/forms/TicketForm";
import CommonContainer from "../../components/common/container/CommonContainer";
import useSnackbarAlert from "../../utils/snackbarHandlers";

const initialData = {
  ticketTitle: "",
  ticketNumber: "",
  slotNumber: "",
  image: "",
  ticketPrice: "",
  ticketDescription: "",
  startDate: "",
  closeDate: "",
  numberOfPack: "",
};

const Create: React.FC = () => {
  const { t } = useTranslation("translation");
  const [loading, setLoading] = React.useState(false);
  const [image, setImage] = React.useState<string>("");
  const navigate = useNavigate();
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";
  let localData = localStorage.getItem('UserData');
  const auth = localData ? JSON.parse(localStorage.getItem('UserData') || "") : null;

  const onHandleSubmit = (value: any) => {
    setLoading(true);
    const fileHeaders = {
      accept: "application/json",
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "multipart/form-data",
    };
    const body = {
      ticketTitle: value.ticketTitle,
      ticketNumber: value.ticketNumber,
      image: value.image,
      ticketPrice: value.ticketPrice,
      ticketDescription: value.ticketDescription,
      startDate: value.startDate,
      closeDate: value.closeDate,
      numberOfPack: value.numberOfPack,
      addedBy: auth?.fullName,
      status: "ACTIVE",
    };

    axios
      .post(`${apiBaseURL}/api/ticket/add`, body, { headers: fileHeaders })
      .then((data: any) => {
        if (data?.status == 200) {
          //   setImage("");
          //   resetForm();
          showSuccessMessage(t("ticketAddSuccessfulMsg", "Ticket Added Successfully"))
          navigate('/admin/dashboard');
        }
      })
      .catch((err: any) => {
        console.log("err", err);
        showErrorMessage(t("somethingWentWrong"))
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <CommonContainer title={t("createTicket")} description={t("createTicketPageDescription")} backButtonurl="/admin/dashboard">
      <TicketForm
        data={initialData}
        onFormSubmit={(values) => onHandleSubmit(values)}
        loading={loading}
        image={image}
        setImage={setImage}
      />
    </CommonContainer>
  );
};

export default Create;
